import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import { Flex } from 'components/base/layout-components';
import MetricsBenchmarkIcon from 'components/MetricsBenchmarkIcon';
import { getDescription } from '../groupDashboard.service';
import useMetricsCalculationConfig from 'views/root/views/home/hooks/useMetricsCalculationConfig';
import { isMedianMetric } from '../../../performance/views/CustomReport/custom-report.util';
import {
  METRICS_CALCULATION_STRATEGY_LABEL,
  metricDisplayValues
} from '@linearb/linjs-common';
import TrendLine from './components/TrendLine';
import GroupWidgetNoData from './components/GroupWidgetNoData';
import GroupWidgetNotEnoghData from './components/GroupWidgetNotEnoghData';
import GroupWidgetHeader from './components/GroupWidgetHeader';
import { WidgetSkeleton } from '@linearb/linui-common';
import WidgetDescription from '../../../performance/views/CustomReport/Widgets/CustomWidget/Header/WidgetDescription';

export const StyledWidgetBox = styled(Flex)`
  & .edit-btn {
    visibility: hidden;
  }
  :hover {
    & .edit-btn {
      visibility: unset;
    }
  }
`;

const GroupMetricsWidgetNew = ({
  isWidgetLoading,
  widgetMetricName,
  widgetMetricValue,
  displayValueText,
  selectedGroupId,
  availableMetricsWidget,
  onClick = _.noop,
  isCustomizeMetrics,
  trendLineData = [],
  granularity
}) => {
  const { metricsCalculationStrategy } = useMetricsCalculationConfig();

  const name = _.get(availableMetricsWidget, 'name', '');
  const articleId = _.get(availableMetricsWidget, 'articleId', null);
  const displayLabel = _.get(
    metricDisplayValues[widgetMetricName],
    'displayLabel',
    ''
  );

  const description = getDescription(availableMetricsWidget, granularity);
  const shouldShowMedianLabel = isMedianMetric(widgetMetricName);
  const descriptions = [
    ...(shouldShowMedianLabel
      ? [
          _.capitalize(
            METRICS_CALCULATION_STRATEGY_LABEL[metricsCalculationStrategy]
          )
        ]
      : []),
    description
  ];

  return (
    <StyledWidgetBox
      direction='column'
      height='21.55rem'
      borderRadius='0.45rem'
    >
      <GroupWidgetHeader
        name={name}
        articleId={articleId}
        isCustomizeMetrics={isCustomizeMetrics}
        onClick={onClick}
      />
      {isWidgetLoading ? (
        <WidgetSkeleton sx={{ padding: '1rem' }} />
      ) : (
        <>
          {!!widgetMetricValue && (
            <Flex height='7.5rem' direction='column' pt='0'>
              <Flex pr='1rem'>
                <MetricsBenchmarkIcon
                  selectedTeamId={selectedGroupId}
                  metricName={widgetMetricName}
                  value={widgetMetricValue === 0 ? null : widgetMetricValue}
                  margin='0 1rem -5px 1.5rem'
                  data-testid='metric-widget-benchmark'
                  granularity={granularity}
                  popperPlacement='bottom'
                />

                <WidgetDescription
                  formattedAverage={displayValueText}
                  formattedDescription={descriptions.join(' ')}
                  dataCyPrefix={name}
                />
              </Flex>
            </Flex>
          )}
          {trendLineData.length < 2 && !!widgetMetricValue && (
            <GroupWidgetNotEnoghData />
          )}
          {!widgetMetricValue && <GroupWidgetNoData />}
          {trendLineData.length > 1 && !!widgetMetricValue && (
            <TrendLine
              trendLineData={trendLineData}
              displayLabel={displayLabel}
              widgetMetricName={widgetMetricName}
              selectedGroupId={selectedGroupId}
            />
          )}
        </>
      )}
    </StyledWidgetBox>
  );
};

export default GroupMetricsWidgetNew;
